module.exports = __webpack_public_path__ + "static/media/siddharth-yelahanka-trip-01.75f31429.png";